import AbstractCalls from "./AbstractCalls";

class DataGridPresetCalls extends AbstractCalls {
  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "dataGridPreset/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  create(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "dataGridPreset/create");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  rename(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "dataGridPreset/rename");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  setDefault(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "dataGridPreset/setDefault");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  delete(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "dataGridPreset/delete");
    return AbstractCalls.delete(cmdUri, dtoIn, options);
  }
}

export default new DataGridPresetCalls();
